import React, { useEffect, useMemo, useCallback } from 'react';
import { Typography } from '@mui/material';
import { useRequest } from 'shared/hooks';
import api from 'api';
import { PAGINATION_PAGE_SIZE } from 'utils/constants';
import { FlexBoxColumn } from 'styles/layout';
import ResourceItem from './components/ResourceItem';

const ClinicalDecisionSupportPage = () => {
  const { doRequest, data: listData = [] } = useRequest(api.getUserSupportData);

  const listItems = useMemo(() => listData?.data || [], [listData]);

  const fetchList = useCallback(() => {
    doRequest({
      page: 1,
      pageSize: PAGINATION_PAGE_SIZE,
      sortOrder: 'asc',
      sortBy: 'OrderNumber',
    });
  }, [doRequest]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  return (
    <FlexBoxColumn p={3}>
      {listItems.length === 0 ? (
        <Typography>No data available.</Typography>
      ) : (
        listItems.map((item) => (
          <ResourceItem key={item.id || item.title} item={item} />
        ))
      )}
    </FlexBoxColumn>
  );
};

export default ClinicalDecisionSupportPage;
